import { render, staticRenderFns } from "./applet-card.vue?vue&type=template&id=d5816cc2&scoped=true"
import script from "./applet-card.vue?vue&type=script&lang=js"
export * from "./applet-card.vue?vue&type=script&lang=js"
import style0 from "./applet-card.vue?vue&type=style&index=0&id=d5816cc2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5816cc2",
  null
  
)

export default component.exports